module.exports = __webpack_public_path__ + "img/郾城区.728dedee.png";